import React, { useEffect } from 'react'
import {
    BrowserRouter,
    Navigate,
    Route,
    Routes,
    useParams,
    useNavigate
  } from "react-router-dom";
  import Welcome from "../Login/Welcome/Welcome";
import Onboarding from "../Login/Onboarding/Onboarding";
import DesigneraddRole from '../Login/Onboarding/DesigneraddRole';





const OnboardingRouting = (props) => {
    const Navigate=useNavigate();

    useEffect(()=>
    {
        Navigate("/welcome")
    },[])

  



  return (
   <>
 <Routes>


<Route exact path='/' element={<Navigate to="/welcome"/> }/>
<Route exact path='/welcome' element={<Welcome state={props.state}/> }/>
    <Route exact path='/welcome/onboarding' element={<Onboarding state={props.state}/> }/>
    <Route exact path='/welcome/onboarding/random' element={<DesigneraddRole state={props.state}/>}/>
    </Routes>
   </>
  )
}

export default OnboardingRouting;